import { Navigate } from "react-router-dom";
import {
  TRIGGER_ACTION_ID_PARAM,
  TRIGGER_ACTION_LIST_PATH,
} from "@/modules/automation/pages/trigger-action-list";
import { ToPageNotFound } from "@/shared/redirects/to-page-not-found";

export function OpenTriggerAction() {
  const url = new URL(window.location.href);
  const id = url.searchParams.get("id");

  if (!id) {
    return <ToPageNotFound />;
  }

  const params = new URLSearchParams({ [TRIGGER_ACTION_ID_PARAM]: id });

  return <Navigate to={`${TRIGGER_ACTION_LIST_PATH}?${params}`} />;
}
